import { PropsWithChildren, ReactElement } from "react";
import classNames from "classnames";
import { Icon } from "../Icon/Icon";
import styles from "./VideoThumbnail.module.less";
import { MediaPlaceholderSize } from "../MediaPlaceholder/MediaPlaceholder";

export type PlayButtonColorKind = "default" | "black-semi-transparent" | "app";

export type VideoThumbnailProps = {
	buttonSize?: MediaPlaceholderSize;
	buttonColor?: PlayButtonColorKind;
};

const buttonSizeToStylesMap: { [key in MediaPlaceholderSize]: string | null } = {
	"extra-small": styles.playButton_extraSmall,
	"small": null,
	"medium": styles.playButton_medium,
	"large": styles.playButton_large,
	"extra-large": styles.playButton_extraLarge
};

const buttonColorToStylesMap: { [key in PlayButtonColorKind]: string | null } = {
	"default": null,
	"black-semi-transparent": styles.playButton_blackSemiTransparent,
	"app": styles.playButton_app
};

export const VideoThumbnail = (props: PropsWithChildren<VideoThumbnailProps>): ReactElement => {
	const {
		buttonSize = "small",
		buttonColor = "default",
		children
	} = props;
	return (
		<div className={styles.root}>
			{children}
			<div className={classNames(
				styles.playButton,
				buttonSizeToStylesMap[buttonSize],
				buttonColorToStylesMap[buttonColor]
			)}>
				<span className={styles.iconWrapper}>
					<Icon value="play" />
				</span>
			</div>
		</div>
	);
};

VideoThumbnail.displayName = "VideoThumbnail";